/**
 * @description 关于分类接口API  http://api.umucdn.cn/project/399/interface/api/6170
 * @author liushuai
 */

import { API_TYPE } from '@umu/umu-fetch';
const BASE_MODULE = '/recommend';
const PRE_BASE = '/uapi/v1';
export const CategoryAPI = {
    // 搜索课程(学习项目)接口
    PARSE_URL: {
        url: `${PRE_BASE}/enterprise/parse-url`,
        type: API_TYPE.GET,
    },
    PARSE_CIRCLE_URL: {
        url: `${PRE_BASE}/learning-circle/get-enterprise-circle-info-by-code-url`,
        type: API_TYPE.GET,
    },
    SUBCHANNEL_LIST: {
        url: `${PRE_BASE}${BASE_MODULE}/get-subchannel-list-by-pid`,
        type: API_TYPE.GET,
    },
    SUBCHANNEL_MODULE: {
        url: `${PRE_BASE}${BASE_MODULE}/get-subchannel-module-list`,
        type: API_TYPE.GET,
    },
    SUBCHANNEL_SET: {
        url: `${PRE_BASE}${BASE_MODULE}/set-subchannel-setup`,
        type: API_TYPE.POST,
    },
    SUBCHANNEL_SET_MODULES: {
        url: `${PRE_BASE}${BASE_MODULE}/set-subchannel-modules`,
        type: API_TYPE.POST,
    },
    MODULE_CONTENT_LIST: {
        url: `${PRE_BASE}${BASE_MODULE}/get-module-content-list`,
        type: API_TYPE.GET,
    },
    MODULE_FLLOWED_ADD: {
        url: '/ajax/follow/add',
        type: API_TYPE.POST,
    },
    MODULE_FLLOWED_DEL: {
        url: '/ajax/follow/delete',
        type: API_TYPE.POST,
    },
    COURSE_LIST_BY_ID: {
        url: '/uapi/v1/search/index',
        type: API_TYPE.GET,
    },
    STAT_CLICK: {
        url: '/uapi/v1/stat/common-click',
        type: API_TYPE.POST,
    },
    CIRCLE_STATUS_CLICK: {
        url: '/uapi/v1/learning-circle/status-read-save',
        type: API_TYPE.POST,
    },
};
